export default [{
    path: "/answer/everyday_answer",
    name: "EverydayAnswers",
    meta: {
      title: "每日答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/everyday_answer.vue")
  },
	{
		path: "/answer/party",
		name: "PartyAnswers",
		meta: {
			title: "入党积极分子考试",
			keepAlive: false,
			backgroundColor: "#ffffff"
		},
		component: () => import("@views/answer/party.vue")
	},
  {
    path: "/answer/challenge_answer",
    name: "ChallengeAnswer",
    meta: {
      title: "挑战答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/challenge_answer.vue")
  },
  {
    path: "/answer/tzDati",
    name: "ChallengeAnswer",
    meta: {
      title: "挑战答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/tzDati.vue")
  },
  {
    path: "/answer/video_answer",
    name: "VideoAnswer",
    meta: {
      title: "视频答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/video_answer.vue")
  },
  {
    path: "/answer/rankList",
    name: "RankList",
    meta: {
      title: "排行榜",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/rankList.vue")
  },
  {
    path: "/answer/dati",
    name: "Dati",
    meta: {
      title: "每日答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/dati.vue")
  },
	{
	  path: "/answer/partydati",
	  name: "PartyDati",
	  meta: {
	    title: "入党积极分子考试答题",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/partydati.vue")
	},
	{
	  path: "/answer/topicBank",
	  name: "topicBank",
	  meta: {
	    title: "学习题库",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/topicBank.vue")
	},
	{
	  path: "/answer/survey",
	  name: "survey",
	  meta: {
	    title: "问卷调查",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/survey.vue")
	},
	{
	  path: "/answer/datiRecord",
	  name: "datiRecord",
	  meta: {
	    title: "答题记录",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/datiRecord.vue")
	},
	{
	  path: "/answer/datiRecordList/:id?",
	  name: "datiRecordList",
	  meta: {
	    title: "答题记录",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/datiRecordList.vue")
	},
	{
	  path: "/answer/serveyRecord",
	  name: "serveyRecord",
	  meta: {
	    title: "问卷记录",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/serveyRecord.vue")
	},
	{
	  path: "/answer/serveyRecordList/:id?",
	  name: "serveyRecordList",
	  meta: {
	    title: "问卷记录",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/serveyRecordList.vue")
	},
	{
	  path: "/answer/surveyList",
	  name: "surveyList",
	  meta: {
	    title: "问卷调查",
	    keepAlive: false,
	    backgroundColor: "#ffffff"
	  },
	  component: () => import("@views/answer/surveyList.vue")
	},
  {
    path: "/answer/videoDati",
    name: "videoDati",
    meta: {
      title: "视频答题",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/answer/videoDati.vue")
  },
];